export const HT_LUBRICANT = 'HT LUBRICANT SDN BHD'
export const HT_PERFORMANCE = 'HT PERFORMANCE TYRE SDN BHD'
export const HT_TRUCK = 'HT TRUCK SERVICE SDN BHD'
export const HT_TYREHUB = 'HT TYREHUB SDN BHD'
export const HT_ECO_BATTERY = 'HT ECO BATTERY SDN BHD'
export const HT_BRAKES = 'HT BRAKES SDN BHD'
export const HT_EKOTAYAR = 'HT EKOTAYAR SDN BHD'

export const HTG_COMPANIES = [
  HT_TYREHUB,
  HT_PERFORMANCE,
  HT_LUBRICANT,
  HT_TRUCK,
  HT_ECO_BATTERY,
  HT_BRAKES,
  HT_EKOTAYAR,
]

const ADDRESS_HT_TRUCK = `HQ: 90, Jalan Tampoi, 81200 Johor Bahru, Johor Phone: 607-3358989 Fax: 607-3358600
Branch: PLO 53, Jalan Perak 2, Kawasan Perindustrian Pasir Gudang, 81700 Pasir Gudang, Johor Phone: 607-­2541990 Fax: 607­-2541997
Branch: No. 6, Jalan SILC 2/19, Kawasan Perindustrian SILC, 79200 Iskandar Puteri, Johor Phone / Fax : 607-5705990`

const ADDRESS_HT_OTHERS = `HQ: 90, Jalan Tampoi, 81200 Johor Bahru, Johor Phone: 607-3358989 Fax: 607-3358600
Branch: Lot 2167, Jalan Abadi 4, Taman Malim Jaya, 75250 Melaka, Melaka Phone: 606-3353755 Fax: 606-3342160
Branch: 6A, Jalan Industri Semambu 10/3, Kawasan Perindustrian Semambu, 25350 Kuantan, Pahang Phone: 609-560 1313/609-560 6363
Branch: 11, Jalan TPP 3, Taman Perindustrian Putra, 47130 Puchong, Selangor Phone: 03-80668336/80689336 Fax: 03-8066 8749`

const htgCompanies = {
  [HT_LUBRICANT]: {
    name: 'HT LUBRICANT SDN BHD',
    shortName: 'Lubricant',
    fullName: 'HT LUBRICANT SDN. BHD. (646137-M)',
    logo: 'HT-LUBRICANT-SDN-BHD.png',
    address: ADDRESS_HT_OTHERS,
    htgShort: 'HTL',
  },
  [HT_PERFORMANCE]: {
    name: 'HT PERFORMANCE TYRE SDN BHD',
    shortName: 'Performance Tyre',
    fullName: 'HT PERFORMANCE TYRE SDN. BHD. (1320716-D)',
    logo: 'HT-PERFORMANCE-TYRE-SDN-BHD.png',
    address: ADDRESS_HT_OTHERS,
    htgShort: 'HTP',
  },
  [HT_TRUCK]: {
    name: 'HT TRUCK SERVICE SDN BHD',
    shortName: 'Truck Service',
    fullName: 'HT TRUCK SERVICE SDN. BHD. (401126-­P)',
    logo: 'HT-TRUCK-SERVICE-SDN-BHD.png',
    address: ADDRESS_HT_TRUCK,
    htgShort: 'HTT',
  },
  [HT_TYREHUB]: {
    name: 'HT TYREHUB SDN BHD',
    shortName: 'Tyrehub',
    fullName: 'HT TYREHUB SDN. BHD. (68981-T)',
    logo: 'HT-TYREHUB-SDN-BHD.png',
    address: ADDRESS_HT_OTHERS,
    htgShort: 'HWT',
  },
  [HT_ECO_BATTERY]: {
    name: HT_ECO_BATTERY,
    shortName: 'Eco Battery',
    fullName: 'HT ECO BATTERY SDN. BHD. (1179797-T)',
    logo: 'HT-ECO-BATTERY.png',
    address: ADDRESS_HT_OTHERS,
    htgShort: 'HTE',
  },
  [HT_BRAKES]: {
    name: HT_BRAKES,
    shortName: 'Brakes',
    fullName: 'HT BRAKES SDN. BHD. (1157733-M)',
    logo: 'HT-BRAKES.png',
    address: ADDRESS_HT_OTHERS,
    htgShort: 'HTB',
  },
  [HT_EKOTAYAR]: {
    name: HT_EKOTAYAR,
    shortName: 'EkoTayar',
    fullName: 'HT EKOTAYAR SDN. BHD. (1589424-K)',
    logo: 'HT-EKOTAYAR.png',
    address: ADDRESS_HT_OTHERS,
    htgShort: 'EKT',
  },
}

export default htgCompanies
